// extracted by mini-css-extract-plugin
export default {"container":"CashbackNotice-module__container__ln+sV","icon":"CashbackNotice-module__icon__Q7d5+"};